<template>

	<div class="cmpnt-box">
		<header class="lmy-header lmy-header-w">
            <i class="iconfont icon-yuyin" @click="lmData.show=false"></i>
        	{{lmData.GroupName}}
    	</header>
	    <div class="lmy-search-list">
	        <div class="list-item" v-for="lm in list" @click="select(lm)">
	        	{{lm.Name}}
	        </div>
	        <div class="infinite-loading-containers" v-if="!list">
				<i class="loading-defaults"></i>
			</div>
	    </div>
	</div>
	
</template>
<script>
	export default{
		name:'land-mark-more',
		props:{
			lmData:{
				type:Object,
				default:()=>{
					return{}
				}
			}
		},
		data(){
			return{
				list:''
			}
		},
		watch:{
			lmData(val){

				this.getLandmarks();
			}
		},
		methods:{
			getLandmarks(){
				var that=this;
   				var params={
                    isCN:this.lmData.from==1?true:false,
                    pid:this.lmData.RegionID,
                    q:'',
                    group:this.lmData.group,
                    pageSize:100,
                }
                that.getRequest({
                    url: that.Api.getLandmarkGroups,
                    params: params
                }).then(res => {
                    if(res&&res.IsSuccess){
                    	that.list=res.Result[0].Landmarks;
                    }
                });
			},
			select(lm){
				this.$emit('select',lm)
			}
		},
		mounted(){
			this.getLandmarks();

		}

	}
</script>


// WEBPACK FOOTER //
// src/components/common/cmpnt/landMarkMore.vue